<!--
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-05-17 16:49:15
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-05-27 17:12:12
 * @FilePath: /dsicm-admin-web/src/views/StandardDatabase/components/Case7Header/index.vue
-->
<template>
    <header>
        <h6>食物类型管理</h6>
        <el-form
        inline
        size="mini"
        :model="seachFormData"
        >
            <el-form-item >
                <el-input 
                style="width:330px"
                prefix-icon="el-icon-search"
                placeholder="请搜索食物类型项目" 
                v-model="seachFormData.redundant">
                </el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="inquireHeader" style="background:#1A7BFC">搜索</el-button>
            </el-form-item>

        </el-form>
    </header>
</template>

<script>
export default {
    name:'CaseHeader-2',
    data(){
        return{
            seachFormData:{
                redundant:'',//查询条件
            },
        }
    },
    methods:{
       
        /**
         * @description: 搜索
         * @param {*}
         * @return {*}
         */    
        inquireHeader(){
            this.$emit('inquire',this.seachFormData)
        },
      
    }
}
</script>

<style lang="less" scoped>
    header{
        height: 126px;
        padding: 24px;
        box-sizing: border-box;
        background: #fff;
        border-bottom: 16px solid #F8F8F8;
        h6{
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
            margin-bottom: 12px;
        }
    }
    .el-form{
        & /deep/.el-form-item__label{
            color: #333333;
            font-size: 12px;
        }
    }
   
</style>